import { EWorldMapSetType } from '__generated__/globalTypes';
import { GeneralMapSetSection } from 'components/minute/sidebar/MapSidebar/MapSetSection/GeneralMapSetSection';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const FloorsSettingSection = (props: Props): JSX.Element => {
    return (
        <S_FloorsSecttingSection className={props.className}>
            <GeneralMapSetSection
                mapSetType={EWorldMapSetType.FLOOR}
                sectionIcon={'layer-group'}
                strings={{
                    addButtonTitle: Localization.ADD_FLOOR,
                    sectionTitle: Localization.FLOORS,
                    deleteConfirmationMessage: Localization.DELETE_FLOOR_CONFIRM,
                    newSetTitle: Localization.FLOOR_NR
                }}
            />
        </S_FloorsSecttingSection>
    );
};

const S_FloorsSecttingSection = styled.div``;
